import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["title"];
const _hoisted_2 = { class: "cy-name item-col name" };
const _hoisted_3 = { class: "va-m" };
const _hoisted_4 = { class: "item-col" };
const _hoisted_5 = { class: "item-col" };
const _hoisted_6 = ["title"];
import { mapControl } from '@/constants';
import vuexStore from '@/vuex-store';
import { modalWorkerInfoActionType } from '@/vuex-store/modal-worker-info/actions';
import { computed, ref, toRefs } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkerItem',
    props: {
        isRelatedWorker: { type: Boolean, default: false },
        onClickWorkerItem: { type: Function, default: () => { } },
        workerData: { default: () => ({}) },
        isSelected: { type: Boolean, default: false }
    },
    setup(__props) {
        const props = __props;
        const { onClickWorkerItem, workerData, isRelatedWorker, isSelected, } = toRefs(props);
        const showClickButton = ref(false);
        const user = computed(() => workerData.value.user);
        const name = computed(() => user.value.name);
        const isGpsOn = computed(() => user.value.isGpsOn);
        const isShareWorker = computed(() => workerData.value.isShareWorker);
        const allocatedCount = computed(() => workerData.value.allocatedCount);
        const pickupCount = computed(() => props.workerData.pickupCount);
        const cssClassWorkerItem = computed(() => {
            const className = `cy-wk-${workerData.value.user.code}`;
            return {
                [className]: true,
                selected: isSelected.value,
                'related-worker': isRelatedWorker.value,
                'share-worker': isShareWorker.value,
            };
        });
        const status = computed(() => (workerData.value.isTemporallyOff
            ? mapControl.mapControlAttendCode.OFF.text
            : mapControl.mapControlAttendCode[user.value.attendCode].text));
        const statusColor = computed(() => `color: ${workerData.value.isTemporallyOff
            ? mapControl.mapControlAttendCode.OFF.textColor
            : mapControl.mapControlAttendCode[user.value.attendCode].textColor}`);
        const setIsOpenModalWorkerInfo = (value) => {
            vuexStore.dispatch(modalWorkerInfoActionType.setIsOpenModalWorkerInfo, value);
        };
        const handleClickWorkerItem = () => {
            onClickWorkerItem.value(workerData.value);
        };
        const handleEnterItem = () => {
            showClickButton.value = true;
        };
        const handleLeaveItem = () => {
            showClickButton.value = false;
        };
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            return (_openBlock(), _createElementBlock("div", {
                title: user.value.code,
                "data-cy": "worker-item",
                class: _normalizeClass(["root-worker-item", cssClassWorkerItem.value]),
                onClick: handleClickWorkerItem,
                onMouseenter: handleEnterItem,
                onMouseleave: handleLeaveItem
            }, [
                _withDirectives(_createVNode(_component_v_btn, {
                    small: "",
                    variant: "outlined",
                    height: "32",
                    class: "btn-detail-worker",
                    title: "상세정보",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (setIsOpenModalWorkerInfo(user.value.code)), ["stop"]))
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_icon, { size: "20" }, {
                            default: _withCtx(() => [
                                _cache[1] || (_cache[1] = _createTextVNode(" mdi-magnify ")),
                                _createCommentVNode(" {{ $t(lc + 'order_info') }} ")
                            ]),
                            _: 1 /* STABLE */,
                            __: [1]
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */), [
                    [_vShow, showClickButton.value]
                ]),
                _createCommentVNode(" color tag "),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "color-tag" }, null, -1 /* CACHED */)),
                _createCommentVNode(" 이름 "),
                _createElementVNode("span", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(name.value), 1 /* TEXT */)
                ]),
                _createCommentVNode(" 상태 "),
                _createElementVNode("span", {
                    class: "item-col",
                    style: _normalizeStyle(statusColor.value)
                }, _toDisplayString(_ctx.$t(status.value)), 5 /* TEXT, STYLE */),
                _createCommentVNode(" 배차 "),
                _createElementVNode("span", _hoisted_4, _toDisplayString(allocatedCount.value), 1 /* TEXT */),
                _createCommentVNode(" 픽업 "),
                _createElementVNode("span", _hoisted_5, _toDisplayString(pickupCount.value), 1 /* TEXT */),
                _createCommentVNode(" GPS "),
                _createElementVNode("span", {
                    class: _normalizeClass(["item-col gps-icon", isGpsOn.value && 'gps-icon-on'])
                }, [
                    _createElementVNode("span", {
                        title: isGpsOn.value ? 'on' : 'off'
                    }, null, 8 /* PROPS */, _hoisted_6)
                ], 2 /* CLASS */)
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1));
        };
    }
});
